
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandshake, faCalendarDays, faRibbon, faNewspaper } from '@fortawesome/free-solid-svg-icons'
import React from 'react';
import './TestPage.scss';
import { Col, Row } from 'react-bootstrap';

class TestPage extends React.Component {
  render() {
    return (
      <>
        <Row pt-3>
          <Col lg="3" md="4">
            <div className="p-4 border-light border rounded cc">
              <div className="d-flex justify-content-center align-items-center box-100 mx-auto">
                <FontAwesomeIcon className="big-icon" icon={faHandshake} />
              </div>
              <h4 className="mb-3 mt-5">What We Do</h4>
            </div>
          </Col>
          <Col lg="3" md="4">
            <div className="p-4 border-light border rounded cc">
              <div className="d-flex justify-content-center align-items-center border rounded-circle box-100 mx-auto">
                <FontAwesomeIcon className="big-icon" icon={faRibbon} />
              </div>
              <h4 className="mb-3 mt-5">Charities</h4>
            </div>
          </Col>
          <Col lg="3" md="4">
            <div className="p-4 border-light border rounded cc">
              <div className="d-flex justify-content-center align-items-center border rounded-circle box-100 mx-auto">
                <FontAwesomeIcon className="big-icon" icon={faCalendarDays} />
              </div>
              <h4 className="mb-3 mt-5">Events</h4>
            </div>
          </Col>
          <Col lg="3" md="4">
            <div className="p-4 border-light border rounded cc">
              <div className="d-flex justify-content-center align-items-center border rounded-circle box-100 mx-auto">
                <FontAwesomeIcon className="big-icon" icon={faNewspaper} />
              </div>
              <h4 className="mb-3 mt-5">News</h4>
            </div>
          </Col>
        </Row>

      </>

    );
  }
}

export default TestPage;